module.exports = __webpack_public_path__ + "img/3.e0a1cea1.png";